import { ResizeObserverElement } from './resize-observer.js';

ResizeObserverElement.defineCustomElement();

export { ResizeObserverElement };
